import { z } from 'zod';
export const platformCustomDomainIdSchema = z.string().uuid();
export const platformCustomDomainVersionSchema = z.number().int().positive();
export const platformCustomDomainSurfaceSchema = z.enum(['web', 'portal']);
export const platformCustomDomainStateSchema = z.enum([
    'pending-verification',
    'verified',
    'disabled',
    'revoked',
    'unavailable',
]);
export const platformCustomDomainCertificateStatusSchema = z.enum([
    'pending',
    'healthy',
    'expiring',
    'expired',
    'unavailable',
    'revoked',
]);
export const platformOperationalProviderHealthSchema = z.enum([
    'healthy',
    'degraded',
    'unavailable',
    'revoked',
]);
export const platformNormalizedHostnameSchema = z
    .string()
    .min(1)
    .max(253)
    .regex(/^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/, 'Hostname must be normalized lowercase ASCII without a scheme, path, port, or wildcard.');
export const platformCustomDomainReferenceSchema = z.strictObject({
    customDomainId: platformCustomDomainIdSchema,
    version: platformCustomDomainVersionSchema,
});
export const platformCustomDomainSchema = z.strictObject({
    id: platformCustomDomainIdSchema,
    version: platformCustomDomainVersionSchema,
    surface: platformCustomDomainSurfaceSchema,
    hostname: platformNormalizedHostnameSchema,
    state: platformCustomDomainStateSchema,
    certificateStatus: platformCustomDomainCertificateStatusSchema,
    providerHealth: platformOperationalProviderHealthSchema,
    verificationExpiresAt: z.string().datetime({ offset: true }).nullable(),
    certificateExpiresAt: z.string().datetime({ offset: true }).nullable(),
    verifiedAt: z.string().datetime({ offset: true }).nullable(),
    disabledAt: z.string().datetime({ offset: true }).nullable(),
    revokedAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const platformCustomDomainCreateRequestSchema = z.strictObject({
    customDomainId: platformCustomDomainIdSchema.nullable().default(null),
    surface: platformCustomDomainSurfaceSchema,
    hostname: z.string().trim().min(1).max(500),
});
export const platformCustomDomainVerificationSchema = z.strictObject({
    ownershipVerified: z.boolean(),
    certificateStatus: platformCustomDomainCertificateStatusSchema,
    providerHealth: platformOperationalProviderHealthSchema,
    verificationExpiresAt: z.string().datetime({ offset: true }),
    certificateExpiresAt: z.string().datetime({ offset: true }).nullable(),
    providerRecordVersion: z.string().trim().min(1).max(500).nullable(),
    checkedAt: z.string().datetime({ offset: true }),
});
export const platformCustomDomainResponseSchema = z.strictObject({
    data: platformCustomDomainSchema,
});
export const platformCustomDomainListResponseSchema = z.strictObject({
    data: z.array(platformCustomDomainSchema),
});
//# sourceMappingURL=platform-custom-domain.contract.js.map